import React, { useEffect, useMemo, useState } from 'react'
import Modal from '../../../common/modal';
import { Box, Button, Stack } from '@mui/material';
import { Item } from '../../../common/snippets';
import * as sx from '../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../common/dropDownOA';
import Lineinput from '../../../common/lineinput';
import { PostRequest, PostRequestCachedV3 } from '../../../common/api';
import { urls } from '../../../common/constants';
import { removeDuplicatesFromArray } from '../../../common/helper';
import { alertAtom } from '../../../common/jotaiState/globalStateAtoms';
import { useAtom } from 'jotai';
import { useTranslation } from '../../../../i18n/I18nProvider';
const EwayBillConfigModel = (props) => {
    const { translations } = useTranslation()
    const mtpl = translations?.mtplMaster || {}
    const { modelData, updateModal, setOpenEwayBillModel ,selEditLuggageSetting} = props
    const { loginData } = modelData
    const [, setAlert] = useAtom(alertAtom)
    const modalStyle = useMemo(() => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        paddingTop: "10px"
    }), []);
    const [sourceBranchList, setSourceBranchList] = useState([])
    const [selSourceBranch, setSelSourceBranch] = useState()
    const [ewaybillConfig, setEwaybillConfig] = useState({
        ewbUserId: '',
        ewbPassword: '',
        transporterId: '',
    });
    useEffect(() => {
        const obj = {
            intUserID: 0,
            intCompanyID: selEditLuggageSetting.CompanyID,
            intBranchID: 0,
            strBranchName: '',
            strBranchCode: '',
            intStateID: 0,
            intCityID: 0,
            intIsActive: 1,
        }
        PostRequest(urls.getBranchConfigOrEwbillinfo, obj, true, 24 * 60 * 60).then((res) => {
            if (res.status === 'Success') {
                const firstRow = res?.Data?.Table?.[0]
                setSourceBranchList(res?.Data?.Table)
                setSelSourceBranch(firstRow)
                if (firstRow) {
                    setEwaybillConfig({
                        ewbUserId: firstRow.EwbUserId || '',
                        ewbPassword: firstRow.EwbPwd || '',
                        transporterId: firstRow.EWBTransporterId || '',
                    })
                }
            }
        })
    }, [loginData])
    const handleEwaybillChange = (e) => {
        const { name, value } = e.target;
        setEwaybillConfig((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const getSaveEwayBillData = () => {
        if (selSourceBranch === '' || selSourceBranch === ' ') {
            setAlert({ show: true, success: true, msg: mtpl.pleaseSelectBranch || 'Please Select Branch', nextId: '' })
        } else if (ewaybillConfig.ewbUserId === '') {
            setAlert({ show: true, success: true, msg: mtpl.pleaseEnterEwbUserId || 'Please Enter EWBUserId', nextId: '' })
        } else if (ewaybillConfig.ewbPassword === '') {
            setAlert({ show: true, success: true, msg: mtpl.pleaseEnterEwbPassword || 'Please Enter EWBPassword', nextId: '' })
        } else if (ewaybillConfig.transporterId === '') {
            setAlert({ show: true, success: true, msg: mtpl.pleaseEnterTransporterId || 'Please Enter transporterId', nextId: '' })
        } else {
            const obj = {
                CompanyID: selEditLuggageSetting.CompanyID,
                BranchID: selSourceBranch?.BranchID,
                EwbUserId: ewaybillConfig.ewbUserId,
                EwbPwd: ewaybillConfig.ewbPassword,
                EWBTransporterId: ewaybillConfig.transporterId,
            }
            PostRequest(urls.getEWBConfig_InsertUpdate, obj).then((res) => {
                if (res.status === 'Success') {
                    setAlert({ show: true, success: true, msg: mtpl.ewayBillUpdatedSuccessfully || 'E-Way Bill updated successfully', nextId: '' })
                    setOpenEwayBillModel(false)
                } else {
                    setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
                }
            })
        }
    }
    const handleEwayBillBranch = (val) => {
        setSelSourceBranch(val)
        const obj = {
            intUserID: 0,
            intCompanyID: selEditLuggageSetting.CompanyID,
            intBranchID: val.BranchID,
            strBranchName: '',
            strBranchCode: '',
            intStateID: 0,
            intCityID: 0,
            intIsActive: -1,
        }
        PostRequest(urls.getBranchConfigOrEwbillinfo, obj, true, 24 * 60 * 60).then((res) => {
            if (res.status === 'Success') {
                const firstRow = res?.Data?.Table?.[0]
                if (firstRow) {
                    setEwaybillConfig({
                        ewbUserId: firstRow.EwbUserId || '',
                        ewbPassword: firstRow.EwbPwd || '',
                        transporterId: firstRow.EWBTransporterId || '',
                    })
                }
            }
        })
    }
    return (
        <>
            <Modal
                headTxt={modelData.headText}
                width="40%"
                updateModal={updateModal}
                closeId="closeButton"
                modalClass="booking-popup"
                modalStyle={modalStyle}
            >
                <Box
                    className="BranchPageTabContainer scrollBlue"
                    sx={{
                        height: '50vh',
                        overflowY: 'auto',
                        padding: '20px 50px',
                        fontFamily: 'Roboto',
                        fontSize: '16px',
                        color: '#444',
                        width:'100%'
                    }}
                >
                    <div style={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold', marginBottom: '30px' }}>
                        {mtpl.ewbConfig || 'EWB CONFIG'}
                    </div>

                    {/* BRANCH DROPDOWN */}
                    <Stack direction="row" alignItems="center" spacing={2} sx={{ marginBottom: '20px' }}>
                        <div style={{ width: '25%', textAlign: 'right',fontWeight:'700' }}>{(mtpl.branches || 'Branches')}:</div>
                        <Item sx={{ ...sx.itemsx, width: '60%' }}>
                            <DropDownOA
                                label={mtpl.status || 'Status'}
                                id="status"
                                data={removeDuplicatesFromArray(sourceBranchList, 'BranchID') || []}
                                defaultvalue={selSourceBranch?.BranchName || selSourceBranch}
                                onSelect={(val) => handleEwayBillBranch(val)}
                                noCross={true}
                                idKey="BranchID"
                                dataKey="BranchName"
                                minWidth="100%"
                                nextId="loadBtn"
                            />
                        </Item>
                    </Stack>

                    {/* EWBUserId */}
                    <Stack direction="row" alignItems="center" spacing={2} sx={{ marginBottom: '20px' }}>
                        <div style={{ width: '25%', textAlign: 'right',fontWeight:'700' }}>{mtpl.ewbUserId || 'EWBUserId'}:</div>
                        <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '60%' }}>
                            <Lineinput
                                id="ewbUserId"
                                name="ewbUserId"
                                value={ewaybillConfig.ewbUserId}
                                onChange={handleEwaybillChange}
                                style={{ width: '100%' }}
                            />
                        </Item>
                    </Stack>

                    {/* EWBPassword */}
                    <Stack direction="row" alignItems="center" spacing={2} sx={{ marginBottom: '20px' }}>
                        <div style={{ width: '25%', textAlign: 'right',fontWeight:'700' }}>{mtpl.ewbPassword || 'EWBPassword'}:</div>
                        <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '60%' }}>
                            <Lineinput
                                id="ewbPassword"
                                name="ewbPassword"
                                value={ewaybillConfig.ewbPassword}
                                onChange={handleEwaybillChange}
                                style={{ width: '100%' }}
                            />
                        </Item>
                    </Stack>

                    {/* Transporter Id */}
                    <Stack direction="row" alignItems="center" spacing={2} sx={{ marginBottom: '30px' }}>
                        <div style={{ width: '25%', textAlign: 'right',fontWeight:'700' }}>{mtpl.transporterId || 'Transporter Id'}:</div>
                        <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '60%' }}>
                            <Lineinput
                                id="transporterId"
                                name="transporterId"
                                value={ewaybillConfig.transporterId}
                                onChange={handleEwaybillChange}
                                style={{ width: '100%' }}
                            />
                        </Item>
                    </Stack>

                    {/* Buttons */}
                    <Stack direction="row" justifyContent="right" spacing={4} style={{paddingRight:'80px'}}>
                        <Button
                            variant="contained"
                            id="saveBtn"
                            className="btn btn-primary"
                            onClick={getSaveEwayBillData}
                            sx={{ backgroundColor: '#ff5200', color: '#fff', width: '120px' }}
                        >
                            {mtpl.save || 'SAVE'}
                        </Button>
                        <Button
                            variant="contained"
                            id="closeBtn"
                            className="btn btn-primary"
                            onClick={() => setOpenEwayBillModel(false)}
                            sx={{ backgroundColor: '#ff5200', color: '#fff', width: '120px' }}
                        >
                            {mtpl.close || 'CLOSE'}
                        </Button>
                    </Stack>
                </Box>
            </Modal>

        </>
    )
}

export default EwayBillConfigModel